// "Show All" / "All" carry no meaning when summarising a subscription, so we
// strip them. Anything else (named department, status, risk rating, etc.)
// becomes part of the suggestion.
const isUninformative = (value) => {
	if (!value) return true;
	const v = String(value).trim().toLowerCase();
	return v === "" || v === "show all" || v === "all" || v === "none";
};

export const suggestSubscriptionName = ({
	reportName,
	filters = [],
	maxParts = 2,
} = {}) => {
	if (!reportName) return "";
	const informative = filters
		.filter((f) => !isUninformative(f?.value))
		.slice(0, maxParts)
		.map((f) => f.value);
	if (!informative.length) return reportName;
	return `${reportName} — ${informative.join(", ")}`;
};
